import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    margin: "8px 0",
  },
  bubbleWrap: {
    maxWidth: "80%",
  },
  bubble: {
    padding: theme.spacing(1, 1.25),
    borderRadius: 6,
    fontSize: "0.85rem",
    wordBreak: "break-word",
  },
  meSide: { justifyContent: "flex-end" },
  otherSide: { justifyContent: "flex-start" },
  meBubble: {
    backgroundColor: "#dcedc8",
    border: "1px solid #c5e1a5",
  },
  otherBubble: {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
  },
  sender: {
    fontSize: "0.75rem",
    color: "#ec6535",
    fontWeight: 600,
  },
  ts: {
    fontSize: "0.7rem",
    color: "#888",
  },
  chatDataText: {
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
  },
}));

export default function ChatMessage({ msg, mine }) {
  const classes = useStyles();
  const ts = msg.chatTimeStamp
    ? moment(msg.chatTimeStamp).format("DD-MMM-YYYY HH:mm")
    : "";
  const sender =
    msg.chatSenderName ||
    msg.chatSenderEmail ||
    (mine ? "You" : "User");
  return (
    <Box className={`${classes.row} ${mine ? classes.meSide : classes.otherSide}`}>
      <Box className={classes.bubbleWrap}>
        <Box
          className={`${classes.bubble} ${
            mine ? classes.meBubble : classes.otherBubble
          }`}
        >
          <Typography className={classes.sender}>{sender}</Typography>
          <Typography className={classes.ts}>{ts}</Typography>
          <Box style={{ marginTop: 4 }}><Typography variant='caption' className={classes.chatDataText} >{msg.chatData}</Typography></Box>
        </Box>
      </Box>
    </Box>
  );
}
